module.exports = __webpack_public_path__ + "static/media/Ryze_0.68910395.png";